import {create} from "zustand";
import {isMac} from "@cdx/common/device-utils";

const useKeyDownStore = create<{isMetaDown: boolean; isShiftDown: boolean}>((set) => ({
  isMetaDown: false,
  isShiftDown: false,
}));

const isMetaKey = (e: KeyboardEvent) => {
  return isMac() ? e.key === "Meta" : e.key === "Control";
};

window.addEventListener("keydown", (e) => {
  if (isMetaKey(e)) {
    useKeyDownStore.setState({isMetaDown: true});
  } else if (e.key === "Shift") {
    useKeyDownStore.setState({isShiftDown: true});
  }
});
window.addEventListener("keyup", (e) => {
  if (isMetaKey(e)) {
    useKeyDownStore.setState({isMetaDown: false});
  } else if (e.key === "Shift") {
    useKeyDownStore.setState({isShiftDown: false});
  }
});

window.addEventListener("focus", () => {
  // cmd+tabbing leads to a keydown event wihout keyup, just reset it when focussing the window again
  if (document.hasFocus && document.hasFocus()) {
    useKeyDownStore.setState({isMetaDown: false});
  }
});

export const useIsMetaKeyDown = () => {
  return useKeyDownStore((s) => s.isMetaDown);
};

export const useIsShiftKeyDown = () => {
  return useKeyDownStore((s) => s.isShiftDown);
};

export default useIsMetaKeyDown;
